import React, { Component } from "react";
// importing GameCardsWrapper
import GameCardsWrapper from "./GameCardsWrapper";

// This component renders the "Game" its purpose is just to hold the Game heading,paragraph and the "GameCardWrapper".
// but it just holds the whole game.
export class Game extends Component {
  render() {
    return (
      <div className="game">
        <h1>the red dragon</h1>

        <p
          style={{
            textAlign: "center",
            marginBottom: "20px",
            maxWidth: "600px",
          }}
        >
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Cum pariatur
          non, maiores magni fugit praesentium placeat error quia unde
          accusamus.
        </p>
        <GameCardsWrapper />
      </div>
    );
  }
}

export default Game;
